// Following latest examples from open telemetry and signoz
// https://github.com/open-telemetry/opentelemetry-js/tree/main/examples/opentelemetry-web
// https://signoz.io/newsroom/launch-week-1-day-3/

import {
  getWebAutoInstrumentations,
  IResource,
  OTLPTraceExporter,
  registerInstrumentations,
  SimpleSpanProcessor,
  WebTracerProvider,
  ZoneContextManager,
} from "@honeycomb/telemetry";

export const createUserTelemetry = (resource: IResource, apiKey: string, exporterUrl: string) => {
  const provider = new WebTracerProvider({
    resource: resource,
    spanProcessors: [
      new SimpleSpanProcessor(
        new OTLPTraceExporter({
          url: `${exporterUrl}/v1/traces`,
          headers: {
            "signoz-ingestion-key": apiKey,
          },
        })
      ),
    ],
  });

  // Registering instrumentations
  registerInstrumentations({
    instrumentations: [getWebAutoInstrumentations()],
  });

  provider.register({
    // Changing default contextManager to use ZoneContextManager - supports asynchronous operations so that traces are not broken
    contextManager: new ZoneContextManager(),
  });

  // TODO ::: implement user telemetry here
  const userTelemetry = {
    track: console.info,
  };

  return userTelemetry;
};
